import { gql } from '@apollo/client';

export const CREATE_RESOURCE_FILE = gql`
    mutation createResourceFile($input: CreateResourceFileInput!) {
        result: createResourceFile(input: $input) {
            id
            genericFileId
            genericFile 
            createdAt
            updatedAt
        }
    }
`;